// extracted by mini-css-extract-plugin
export default {"primary":"#202872","grey":"#d2d4e3"};